import React from "react";
import moment from "moment";

const SameDaysMessage = ({ config, form }) => {
    if (config && config.sameDaysMessage && config.sameDaysMessage.enabled && config.sameDaysMessage.title && config.sameDaysMessage.message && config.sameDaysMessage.days){
        let today = moment.utc();
        let minDate = today.clone().add(config.sameDaysMessage.days.min, "days").startOf("day");
        let maxDate = today.clone().add(config.sameDaysMessage.days.max, "days").startOf("day");
        let searchingDate = moment.utc(form.arrivalDate);

        if (searchingDate.isSameOrBefore(maxDate) && searchingDate.isSameOrAfter(minDate)){
            return (
                <div className="sameDaysMessage">
                    <h4 dangerouslySetInnerHTML={{ __html: config.sameDaysMessage.title }} />
                    <span dangerouslySetInnerHTML={{ __html: config.sameDaysMessage.message }} />
                </div>
            )
        }

        return null;
    }

    return null;
}

export default SameDaysMessage;